export default  {
    /**
     * 保存对象到缓存
     * @param key 保存
     * @param obj 保存对象
     * @param second 保存时间
     * 
     */
    set(key,obj,second) {
        if(obj){
            var timestamp = Date.parse(new Date());
            var json = {
                data:obj,
                createTime:timestamp,
                outTime:timestamp+second*1000
            };
            localStorage.setItem(key,JSON.stringify(json));
        }else{
            console.error("obj is null");
        }
        
    },
    // 从缓存中获取
    get(key){
       var timestamp = Date.parse(new Date());
       var str = localStorage.getItem(key);
       if(str){
          var json = JSON.parse(str);
          if(json.outTime){
            if(json.outTime<timestamp){
                //过期,清空缓存
                localStorage.removeItem(key);
            }else{
                //正常
                return json.data;
            }
          }
       }
       return null;
    },
    remove(key){
        localStorage.removeItem(key);
    }
}


// WEBPACK FOOTER //
// ./src/utils/cacheKit.js